var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form_step_2",
      model: {
        value: _vm.form,
        callback: function ($$v) {
          _vm.form = $$v
        },
        expression: "form",
      },
    },
    [
      _c(
        "v-row",
        { staticClass: "mb-5" },
        [
          _c(
            "v-col",
            { staticStyle: { "min-height": "400px" }, attrs: { cols: "12" } },
            [
              _c("renters-simple-list", { staticClass: "mt-5" }),
              _vm._v(" "),
              _vm.notes_in_advance
                ? _c("additional-information-input")
                : _vm._e(),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "mt-15 font-weight-bold error--text text-break",
                },
                [
                  _vm._v(
                    '\n                Please check any of the individual reservations above, if correct, push "continue" to move to the checkout page.\n            '
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("steps-navigation", {
        attrs: {
          "error-messages-list": _vm.errorMessagesList,
          errors: _vm.v__getErrors(),
        },
        on: {
          "step-next": _vm.stepNext,
          "step-back": function ($event) {
            return _vm.stepBack({ validate: false, submit: false })
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }